(() => {
  const refreshVisitorCounts = () => {
    document.querySelectorAll('.product-social-proof').forEach((bar) => {
      const count = bar.querySelector('.product-social-proof__visitor-count');
      if (!count) return;

      const min = Number.parseInt(bar.dataset.visitorMin, 10);
      const max = Number.parseInt(bar.dataset.visitorMax, 10);
      if (!Number.isFinite(min) || !Number.isFinite(max)) return;

      const lower = Math.min(min, max);
      const upper = Math.max(min, max);
      count.textContent = String(Math.floor(Math.random() * (upper - lower + 1)) + lower);
    });
  };

  const start = () => {
    refreshVisitorCounts();
    window.setInterval(refreshVisitorCounts, 3000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
